export const normalizeFileMeta = (file: any, index: number = 0) => {
  if (typeof file === 'string') {
    return {
      image: file,
      dataUrl: file,
      url: file,
      id: `initial-${index}`,
      name: `Image ${index + 1}`,
      size: 'n/a',
      type: 'image/png',
    };
  }
  if (!file) {
    return {
      image: '',
      dataUrl: '',
      url: '',
      id: `initial-${index}`,
      name: '',
      size: 'n/a',
      type: '',
    };
  }
  return {
    image: file.image || file.dataUrl || file.url || '',
    dataUrl: file.dataUrl || file.url || '',
    url: file.url || '',
    id: file.id || `initial-${index}`,
    name: file.name || `Image ${index + 1}`,
    size: file.size || 'n/a',
    type: file.type || 'image/png',
  };
};
